import axios from "axios";
axios.defaults.baseURL = process.env.REACT_APP_EYMIO_BASE_URL;

export async function deleteAllFields(mapping_id, token)
{

    return await new Promise((resolve,reject) => {

        axios.delete(`/datasourcemappings/deleteAllFields?access_token=${token}&mapping_id=${mapping_id}`)
            .then(res => {

                resolve(true)
            })
            .catch(err => {

                console.log('ERR: ', err)
                resolve(false)
            })       
    })
}



// WEBPACK FOOTER //
// ./src/actions/mapping.js